<template>
  <div class="login">
    <div class="login_top">
      <div class="login_top_left">
        <!-- <img src="../../assets/img/home/logo.png" alt="" /> -->
        <img src="../../assets/img/leftnav/logo.png" alt="" style="border-radius:50%;"/>
        <span>布尔清单</span>
      </div>
      <!-- <div class="login_top_right">
        <span
          @click="Strike(0)"
          :class="spclk == 0 ? 'spanclick' : 'unspanclick'"
          >注册</span
        >
        <span
          @click="Strike(1)"
          :class="spclk !== 0 ? 'spanclick' : 'unspanclick'"
          >登录</span
        >
      </div> -->
    </div>
    <div class="login_center" ref="lgcenter">
      <!-- <div class="login_left">
        <div>
          <div class="login_left_one">遇见美好时光</div>
          <div>
            <ul>
              <li><i></i><span>列表-全部</span>今天、未来七天 </li>
              <li><i></i> <span>视图-四象限</span>清单视图</li>
              <li><i></i> <span>清单-生活</span>工作、学习、购物、旅行</li>
            </ul>
          </div>
        </div>
      </div> -->
      <!-- <div class="logindl">登录</div> -->
      <div class="login_right" ref="loginright">
        <div class="switchdz">
          <span @click="Strike(1)" :class="spclk == 1? 'currentclc':''">登录</span>
          <span  @click="Strike(0)" :class="spclk == 0? 'currentclc':''">注册</span>
        </div>
        <!-- 登录 -->
        <div v-if="spclk == 1">
          <div class="login_right_one">
            <!-- <span
              @click="LoginMethod(0)"
              :class="logMethod == 0 ? '' : 'logmethod'"
              >验证码登录</span
            > -->
            
            <!-- <span
              @click="LoginMethod(1)"
              :class="logMethod == 1 ? '' : 'logmethod'"
              >密码登录</span
            > -->
          </div>
          <!-- 验证码登录密码登录盒子切换 -->
          <div v-if="logMethod == 0">
            <!-- 验证码登录 -->
            <el-input
              v-model="telephone.tel"
              placeholder="请输入手机号"
            ></el-input>
            <div class="passwordLogIpt">
              <el-input
                v-model="telephone.verification"
                placeholder="验证码"
              ></el-input>
              <span @click="sendAuthCode(telephone.tel)">获取验证码</span>
            </div>
            <div class="logbtn" @click="verificationJump()">登录</div>
            <span
              @click="LoginMethod(1)"
              class="login_right_four"
              >密码登录</span
            >
          </div>
          <div v-if="logMethod == 1">
            <!-- 密码登录 -->
            <el-input
              v-model="formData.luUsername"
              placeholder="请输入手机号"
            ></el-input>
            <div class="passwordLogIpt">
              <el-input
                type="password"
                v-model="formData.luPassword"
                placeholder="请输入密码"
              ></el-input>
              <span @click="Strike(2)">忘记密码</span>
            </div>
            <div class="logbtn" @click="informationJump()">登录</div>
            <span
              @click="LoginMethod(0)"
              class="login_right_four"
              >验证码登录</span
            >
          </div>
          <!-- <div class="login_right_two">
            <span></span>
            <p>使用第三方登录</p>
            <span></span>
          </div> -->
          <!-- <div class="login_right_three">
            <span>
              <img src="../../assets/img/login/weixin.png" alt="" />
              <p>微信登录</p>
            </span>
            <span>
              <img src="../../assets/img/login/QQ.png" alt="" />
              <p>QQ登录</p>
            </span>
            <span>
              <img src="../../assets/img/login/weibo.png" alt="" />
              <p>微博登录</p>
            </span>
          </div> -->
          <!-- <div class="login_right_four" @click="Strike(0)">立即注册</div> -->
        </div>
        <!-- 注册 -->
        <div v-if="spclk == 0" class="register">
          <!-- <div class="register_one">
            <img src="../../assets/img/home/logo.png" alt="" />
            <span>布尔清单</span>
          </div> -->
          <el-input
            v-model="register.luUsername"
            placeholder="请输入手机号"
          ></el-input>
          <el-input
            type="password"
            v-model="luPassword2"
            placeholder="请输入密码"
            style="margin-top: 18px"
          ></el-input>
          <el-input
            type="password"
            v-model="register.luPassword1"
            placeholder="请确认密码"
            style="margin: 18px 0 24px 0"
          ></el-input>
          <div class="logbtn" @click="confirm">注册</div>
          <!-- <div class="login_right_four" style="bottom: 40px" @click="Strike(1)">
            立即登录
          </div> -->
        </div>
        <!-- 忘记密码 -->
        <div v-if="spclk == 2">
          <div class="retrieve">找回密码</div>
          <el-input
            v-model="retrieve.luUsername"
            placeholder="请输入手机号"
            style="margin: 20px 0 20px 0"
          ></el-input>
          <div class="passwordLogIpt" style="margin: 0 0 30px 0">
            <el-input
              v-model="retrieve.verifica"
              placeholder="验证码"
            ></el-input>
            <span @click="sendAuthCode(retrieve.luUsername)">获取验证码</span>
          </div>
          <div class="logbtn" @click="resetPassword">下一步</div>
        </div>
        <!-- 忘记密码重新找回 -->
        <div v-if="spclk == 3">
          <div class="retrieve">设置登录密码</div>
          <el-input
            type="password"
            v-model="retrievePassword"
            placeholder="请设置密码"
            style="margin: 20px 0 20px 0"
          ></el-input>
          <el-input
            type="password"
            v-model="retrieve.luPassword"
            placeholder="请确认密码"
            style="margin: 0 0 20px 0"
          ></el-input>
          <div class="logbtn" @click="pwdchange">下一步</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //账号密码
      formData: {
        luUsername: "",
        luPassword: "",
      },
      //手机号验证码
      telephone: {
        tel: "",
        verification: "",
      },
      //注册手机号密码
      register: {
        luUsername: "",
        luPassword1: "",
      },
      luPassword2: "",
      //找回手机号密码
      retrieve: {
        luUsername: "",
        luPassword: "",
        verifica: "",
      },
      retrievePassword: "",
      //窗口高度
      height: "",
      //注册登录找回密码页面切换控制
      spclk: 1,
      //密码登录验证码登录框切换
      logMethod: 1,
    };
  },
  created() {
    console.log(localStorage.getItem("token"));
    this.formData.luUsername = localStorage.getItem("username");
    console.log(this.formData);
  },
  mounted() {},

  methods: {
    Strike(a) {
      this.spclk = a;
    },
    LoginMethod(a) {
      this.logMethod = a;
    },
    //忘记密码 验证手机号
    resetPassword() {
      var tel = /^1\d{10}$/;
      let strel = this.retrieve.luUsername;
      if (tel.test(strel)) {
        if (this.retrieve.verifica != "") {
          let data = {
            mobile: strel,
            sms_code: this.retrieve.verifica,
          };
          this.$api
            .verificationCode(data)
            .then((res) => {
              console.log(res);
              if (res.data.code == "0") {
                this.spclk = 3;
              } else if (res.data.code == "103") {
                this.$util.mesBoxPop("验证码错误", "warning");
              }
            })
            .catch((err) => {
              console.log(err);
              this.$util.mesBoxPop("验证码错误", "warning");
            });
        }
      } else {
        this.$util.mesBoxPop("手机号不合法", "warning");
      }
    },
    //忘记密码 重置密码
    pwdchange() {
      var ve = /^\d{8,16}$/;
      let mm = this.retrieve.luPassword;
      if (mm == this.retrievePassword) {
        if (ve.test(mm)) {
          let data = {
            new_password: this.retrieve.luPassword,
            mobile: this.retrieve.luUsername,
            sms_code: this.retrieve.verifica,
          };
          this.$api
            .resetPasswordByAuthCode(data)
            .then((res) => {
              console.log(res);
              if (res.code == "0") {
                this.$util.mesBoxPop("密码修改成功", "success");
                this.spclk = 1;
              } else if (res.code == "103") {
                this.$util.mesBoxPop("验证码错误", "warning");
                this.spclk = 2;
              }
            })
            .catch((err) => {
              console.log(err);
              this.$util.mesBoxPop("密码修改失败", "warning");
            });
        } else {
          this.$util.mesBoxPop("密码长度8~16位", "warning");
        }
      } else {
        this.$util.mesBoxPop("两次密码输入不一致", "warning");
      }
    },
    //密码登录跳转
    informationJump() {
      var re = /^1\d{10}$/;
      let str = this.formData.luUsername;
      if (re.test(str)) {
        if (this.formData.luPassword != "") {
          var data = {
            username: this.formData.luUsername,
            password: this.formData.luPassword,
          };
          console.log(data);
          localStorage.clear()
          this.$api
            .loginPassword(data)
            .then((res) => {
              console.log(res);
              if (res.data.code == "0") {
                localStorage.setItem("token", res.data.result.token);
                sessionStorage.setItem("token", res.data.result.token);
                sessionStorage.setItem("userid", res.data.result.user_id);
                localStorage.setItem("username", this.formData.luUsername);
                localStorage.setItem("signtime",Date.parse(new Date()))
                console.log(localStorage.getItem("token"));
                console.log(localStorage.getItem("signtime"));
                //在这存个当前的时间戳
                if (
                  !res.data.result.nickname ||
                  !res.data.result.avatar ||
                  !res.data.result.birthday
                ) {
                  this.$router.push({ name: "information" });
                } else {
                  this.$router.push({ name: "index" });
                }
              } else if (res.data.code == "105") {
                this.$util.mesBoxPop("用户名或密码错误", "warning");
              } else if (res.data.code == "102") {
                this.$util.mesBoxPop("账户未注册", "warning");
              } else {
                this.$util.mesBoxPop(res.data.msg, "warning");
              }
            })
            .catch((err) => {
              this.$util.mesBoxPop("登录失败", "warning");
            });
        } else {
          this.$util.mesBoxPop("密码不能为空", "warning");
        }
      } else {
        this.$util.mesBoxPop("手机号不合法", "warning");
      }
    },
    //获取验证码
    sendAuthCode(index) {
      var re = /^1\d{10}$/;
      let str = index;
      if (re.test(str)) {
        var data = {
          mobile: str,
        };
        this.$api
          .sendAuthCode(data)
          .then((res) => {
            this.$util.mesBoxPop("短信发送成功", "success");
          })
          .catch((err) => {
            this.$util.mesBoxPop("获取太频繁，请稍后再试", "warning");
          });
      } else {
        this.$util.mesBoxPop("手机号不合法", "warning");
      }
    },
    //验证码登录
    verificationJump() {
      var re = /^1\d{10}$/;
      let str = this.telephone.tel;
      if (re.test(str)) {
        if (this.telephone.verification != "") {
          var data = {
            mobile: str,
            sms_code: this.telephone.verification,
          };
          console.log(data);
          this.$api
            .verificationJump(data)
            .then((res) => {
              console.log(res,"登录返回");
              if (res.data.code == "0") {
                localStorage.setItem("token", res.data.result.token);
                localStorage.setItem("bgcnum",0)
                localStorage.setItem("themeClor",'#f2f4f8')
                sessionStorage.setItem("token", res.data.result.token);
                sessionStorage.setItem("userid", res.data.result.user_id);
                if (
                  !res.data.result.nickname ||
                  !res.data.result.avatar ||
                  !res.data.result.birthday
                ) {
                  this.$router.push({ name: "information" });
                } else {
                  this.$router.push({ name: "index" });
                }
              } else if (res.data.code == "105") {
                this.$util.mesBoxPop("验证码错误", "warning");
              } else {
                this.$util.mesBoxPop(res.data.msg, "warning");
              }
            })
            .catch((err) => {
              this.$util.mesBoxPop("登录失败", "warning");
            });
        } else {
          this.$util.mesBoxPop("验证码不能为空", "warning");
        }
      } else {
        this.$util.mesBoxPop("手机号不合法", "warning");
      }
    },
    //注册 /^\d{8,}$/
    confirm() {
      var re = /^1\d{10}$/;
      var ve = /^.{8,16}$/;
      let str = this.register.luUsername;
      let sve = this.register.luPassword1;

      if (re.test(str)) {
        if (this.luPassword2 == sve) {
          if (ve.test(sve)) {
            let data = {
              custom_username: str,
              password: sve,
              source_app: "todo",
            };
            this.$api
              .passwordRegister(data)
              .then((res) => {
                this.$util.mesBoxPop("注册成功", "success");
                console.log(res);
                if (res.data.code == "0") {
                  localStorage.setItem("token", res.data.result.token);
                  sessionStorage.setItem("token", res.data.result.token);
                  sessionStorage.setItem("userid", res.data.result.user_id);
                  if (
                    !res.data.result.nickname ||
                    !res.data.result.avatar ||
                    !res.data.result.birthday
                  ) {
                    this.$router.push({ name: "information" });
                  } else {
                    this.$router.push({ name: "index" });
                  }
                }else {
                  this.$util.mesBoxPop(res.data.msg, "warning");
                }
              })
              .catch((err) => {
                console.log(err);
                this.$util.mesBoxPop("该用户已注册", "warning");
              });
          } else {
            this.$util.mesBoxPop("密码长度8~16位", "warning");
          }
        } else {
          this.$util.mesBoxPop("两次密码输入不一致", "warning");
        }
      } else {
        this.$util.mesBoxPop("手机号不合法", "warning");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  overflow: auto;
  // background: url("../../assets/img/login/bgc.png") no-repeat;
  // background-size: 100% 100%;
  background-color: #F7F7F7;
  padding: 55px 100px 15px 100px;
  .login_top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: 10%;
    div {
      display: flex;
      align-items: center;
    }
    .login_top_left {
      font-size: 24px;
      img {
        margin-right: 20px;
        width: 55px;
        height: 55px;
      }
    }
    .login_top_right {
      span {
        width: 120px;
        height: 45px;
        border-radius: 3px;
        border: solid 1px #ffffff;
        line-height: 45px;
        text-align: center;
        font-size: 21px;
      }
      :nth-child(1) {
        margin-right: 20px;
      }
      .spanclick {
        color: #00ad90;
        background-color: #fff;
      }
      .unspanclick {
        color: #fff;
      }
    }
  }
  .login_center {
    width: 100%;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    .logindl {
      text-align: center;
      font-size: 18px;
      margin: 50px 0 30px 0;
    }
  }
  .login_left {
    .login_left_one {
      margin-bottom: 57px;
      font-family: SourceHanSansSC-Medium;
      font-size: 34px;
      font-weight: bold;
      font-style: italic;
      letter-spacing: 9px;
      color: #ffffff;
    }
    ul {
      i {
        display: inline-block;
        margin-right: 15px;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: #fff;
      }
      li {
        display: flex;
        align-items: center;
        font-family: DFPHannotateW7-GB;
        text-align: center;
        font-size: 20px;
        letter-spacing: 5px;
        color: #ffffff;
        margin-bottom: 36px;
        span {
          width: 160px;
          text-align: left;
        }
      }
    }
  }
  .login_right {
    width: 420px;
    padding: 30px 50px 40px 50px;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0px 4px 32px 3px 
		rgba(0, 0, 0, 0.19);
        margin: 20px auto;
    // margin-left: 18%;
    margin-top: 80px;
    .login_right_four {
      // right: 50px;
      // bottom: 20px;
      display: block;
      font-size: 14px;
      color: #666;
      width: 100%;
      text-align: right;
      // margin-top: 18px;
    }
    .switchdz {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 30px;
      span {
        text-align: center;
        display: block;
        width: 50%;
        color: #333;
        font-size: 18px;
      }
      .currentclc {
        // background-color: #24af9d;
        color: #24af9d;
      }
    }
    .login_right_one {
      font-size: 16px;
      margin: 10px 0 30px 0;
      
      :nth-child(1) {
        margin-right: 42px;
      }
      .logmethod {
        color: #999;
      }
    }
    .passwordLogIpt {
      margin: 28px 0 28px 0;
      width: 100%;
      height: 34px;
      font-size: 12px;
      border-radius: 3px;
      border: 1px solid #d2d2d2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .el-input__inner {
        border: none;
        height: 100%;
      }
      span {
        width: 40%;
      }
    }
    .el-input__inner {
      font-size: 12px;
      height: 34px;
      border-radius: 3px;
      border: 1px solid #d2d2d2;
    }
    .logbtn {
      width: 100%;
      height: 34px;
      margin: 20px 0;
      text-align: center;
      line-height: 34px;
      font-size: 14px;
      color: #fff;
      background-image: linear-gradient(90deg, #24af9d 0%, #20dfb3 100%),
        linear-gradient(#00ad90, #00ad90);
      background-blend-mode: normal, normal;
      box-shadow: 0px 8px 26px 0px rgba(11, 239, 187, 0.3);
      border-radius: 3px;
    }
    .login_right_two {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 23px 0 30px 0;
      span {
        width: 66px;
        height: 1px;
        background-color: #ececec;
      }
      p {
        font-size: 13px;
        color: #999;
      }
    }
    .login_right_three {
      display: flex;
      justify-content: space-around;
      text-align: center;
      font-size: 10px;
      color: #999;
      font-family: PingFang-SC-Medium;
      img {
        width: 18px;
        height: 18px;
        margin-bottom: 10px;
      }
    }
    
    .register_one {
      margin: 0 0 10px 0;
      color: #000;
      font-size: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: 2px;
      img {
        margin-right: 20px;
        width: 32px;
        height: 32px;
      }
    }
    .retrieve {
      margin: 20px 0;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
    }
  }
}
</style>